// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"479bac6d","764":"31e88813","805":"64a8d30c","911":"ebfd3dec","936":"112e71dd"}[chunkId] + ".chunk.js";
};